module.exports = __webpack_public_path__ + "static/media/September_2026_3.7844fb88.webp";